import React from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import './projectpage.scss';

import { useLanguage } from '../../LanguageContext';
import Footer from '../../components/Footer/Footer';
import { Helmet } from 'react-helmet';
import PdfContainer from '../../components/PDFcontainer/PdfContainer';


function ProjectPage() {
  const { selectedLanguage } = useLanguage();

  const formatTextWithHighlight = (text) => {
    const words = text.split(/(\s+)/); // Include gli spazi come separatori
    return words.map((word, index) => {
      // Rileva parole maiuscole con caratteri alfanumerici, simboli e apostrofi
      const isUpperCase = /^[A-ZÀ-Ý0-9.,()’"’-]+$/.test(word.trim());
      if (isUpperCase) {
        return (
          <span className="highlightS" key={index}>
            {word}
          </span>
        );
      }
      return word; // Ritorna la parola originale se non è tutta maiuscola
    });
  };

  return (
    <>
    <Helmet>
      {/* Titolo */}
      <title>{selectedLanguage === 'it' ? 'Bisanzio Svelata - Progetto' : 'Bisanzio Svelata - Project'}</title>

      {/* Meta Tags */}
      <meta name="description" content="Esplora i segreti di Bisanzio con Bisanzio Svelata - un progetto di ricerca dedicato a svelare i misteri dell'Impero Bizantino." />
      <meta name="keywords" content="Bisanzio, Bisanzio Svelata, progetto di ricerca, storia, misteri, Impero Bizantino" />

      {/* Open Graph / Facebook */}
      <meta property="og:title" content="Bisanzio Svelata - Progetto" />
      <meta property="og:description" content="Esplora i segreti di Bisanzio con Bisanzio Svelata - un progetto di ricerca dedicato a svelare i misteri dell'Impero Bizantino." />
      <meta property="og:image" content="https://www.bisanziosvelata.it/bisanziosvelata.png" />
      <meta property="og:url" content="https://www.bisanziosvelata.it/project" />
      <meta property="og:type" content="website" />

      {/* Twitter */}
      <meta property="twitter:title" content="Bisanzio Svelata - Progetto" />
      <meta property="twitter:description" content="Esplora i segreti di Bisanzio con Bisanzio Svelata - un progetto di ricerca dedicato a svelare i misteri dell'Impero Bizantino." />
      <meta property="twitter:image" content="https://www.bisanziosvelata.it/bisanziosvelata.png" />
      <meta property="twitter:url" content="https://www.bisanziosvelata.it/project" />

      {/* URL Canonico */}
      <link rel="canonical" href="https://www.bisanziosvelata.it/project" />
    </Helmet>
    <Container fluid className="bg-container">
      <Row className="justify-content-center align-items-center rowTitleO">
          <Col md={12} sx={12} lg={12} className='homeScritta'>
            <Col md={12} sx={12} lg={12}>
              <h1 className="titleO">
                {selectedLanguage === 'it' ? 'Navigare nell’Italia bizantina'
              : 'Navigating through Byzantine Italy'}
              </h1>
              <h2 className="projectBriefDesc" style={{ textAlign: 'justify' }}>
                {selectedLanguage === 'it'
                  ? formatTextWithHighlight(
                      "Il ricchissimo patrimonio di oggetti bizantini conservati in Italia è costituito da pezzi di varia origine e datazione, caratterizzati da un’ampia gamma di tecniche artistiche: dalla pittura su tavola alla scultura in marmo e legno, dall’intaglio in avorio, osso e steatite all’oreficeria e alla ceramica, dal tessuto alla miniatura. Disseminate senza soluzione di continuità su tutto il territorio nazionale, tali opere formano una rete ancora poco nota, anche a causa di una letteratura di settore tradizionalmente più attenta allo studio dell’arte monumentale e incline a relegare gli oggetti mobili al rango di prodotti delle cosiddette “arti minori”. Con l’obiettivo di rimediare all’assenza di un corpus sistematico di questi oggetti, il Progetto PRIN NAVIGARE NELL’ITALIA BIZANTINA. UN CATALOGO ONLINE PER LA CONOSCENZA E LA VALORIZZAZIONE DI UN PATRIMONIO ARTISTICO SOMMERSO (2017T3ZC3) ha avuto come obiettivo  principale la creazione di BISANZIO SVELATA, un vero e proprio museo virtuale delle opere bizantine esposte nelle chiese, nei musei e nelle collezioni pubbliche e private in Italia. BISANZIO SVELATA intende promuovere l’avanzamento e la diffusione della conoscenza di questo inestimabile patrimonio attraverso un sistema di comunicazione “intermuseale”, facilitando allo stesso tempo l’elaborazione di itinerari tematici sul territorio, con importanti ricadute potenziali nel settore turistico-culturale. Un doppio livello di approfondimento consente di ottenere tanto una presentazione generale degli oggetti, quanto le coordinate storico-critiche più aggiornate sull’argomento. Il progetto ha visto la partecipazione di quattro Atenei (Sapienza Università di Roma, Università degli Studi Roma Tre, Università IULM Milano, Università del Salento) e di numerosi specialisti con esperienza interdisciplinare. I risultati degli studi condotti dalla squadra di ricerca sono stati presentati in occasione del Convegno Internazionale NAVIGARE NELL’ITALIA BIZANTINA. ARTE, MUSEI, MOSTRE, WEB (Roma, 4-6 giugno 2024)."
                    )
                  : formatTextWithHighlight(
                      "Italy’s extensive heritage of Byzantine objects includes works of diverse origins and dates, showcasing a wide range of artistic techniques such as panel painting, marble and wood sculpture, ivory, bone, and steatite carving, goldsmithing, ceramics, textiles, and miniatures. Scattered across the country, these works form a network that remains largely underexplored, partly due to a scholarly tradition that prioritizes monumental art while relegating portable objects to the category of “minor arts.” To address the absence of a systematic catalog of such objects, the PRIN project NAVIGATING THROUGH BYZANTINE ITALY: AN ONLINE CATALOG TO STUDY AND ENHANCE A SUBMERGED ARTISTIC HERITAGE (2017T3ZC3) resulted in the creation of BISANZIO SVELATA, a virtual museum of Byzantine artworks found in churches, museums, and public and private collections across Italy. BISANZIO SVELATA aims to advance and disseminate knowledge of this invaluable heritage through an “intermuseal” communication system while facilitating the development of thematic itineraries in the territory, with significant potential repercussions in the tourism-cultural sector. The dual-layer structure of the records provides access to both a general presentation of the objects and to more up-to-date historical-critical information. The project brought together four universities (Sapienza University of Rome, Roma Tre University, IULM University, and the University of Salento) and a team of experts with interdisciplinary backgrounds. The results of the studies conducted by the research team were presented at the international conference NAVIGARE NELL’ITALIA BIZANTINA: ARTE, MUSEI, MOSTRE, WEB (Rome, June 4–6, 2024)."
                    )}
              </h2>
            </Col>
            {/* <Col md={4} sx={4} lg={4}>
              <CarouselPages />
            </Col> */}
          </Col>
      </Row>
      <Row className="justify-content-center align-items-center">
        <Col md={6} sx={12} lg={6} className='pt-3'>
          <br></br>
          <h3 style={{textAlign: 'center'}}>
            Convegno internazionale di studi, Roma, 4-6 giugno 2024
          </h3>
          <br></br>
          <PdfContainer pdfUrl="./Poster.pdf" defaultZoomMobile={0.10} defaultZoomDesktop={0.2} />
          <br></br><br></br>
        </Col>
    
        <Col md={6} sx={12} lg={6} className='pt-3'>
          <br></br>
          <h3 style={{textAlign: 'center'}}>
            Antonio Iacobini - Verso un museo digitale 2022
          </h3>
          <br></br>
          <PdfContainer pdfUrl="./Antonio Iacobini - Verso un museo digitale 2022.pdf" defaultZoomMobile={0.20} defaultZoomDesktop={0.35}/>
          <br></br><br></br>
        </Col>
      </Row>
    </Container>
    <Footer />
    </>
  );
}

export default ProjectPage;
